import { SVGProps, useId } from "react";

export default function CircleFilledIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 18, width = 18, stroke = "#F9BAA0", ...rest } = props;
  const id = useId();

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <circle
        cx="9"
        cy="9"
        r="8"
        fill={`url(#paint0_${id})`}
        stroke={stroke}
        strokeWidth="2"
      />
      <defs>
        <linearGradient
          id={`paint0_${id}`}
          x1="9"
          y1="1"
          x2="9"
          y2="17"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
      </defs>
    </svg>
  );
}
